export const safeAccessWithErrorHandler = (
	action: () => string | void | null,
	errorCase?: () => void,
) => {
	try {
		return action();
	} catch (err) {
		return errorCase && errorCase();
	}
};
